import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

const Container = tw.div`py-16 bg-primary-500 text-white relative overflow-hidden`;
const BackgroundPattern = tw.div`absolute top-0 left-0 w-full h-full opacity-5 bg-[url('https://www.transparenttextures.com/patterns/arabesque.png')]`;
const ContentWrapper = tw.div`max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10`;

// Section Header Components
const HeaderContainer = tw.div`text-center mb-12`;
const UrduHeading = tw.h2`text-3xl font-extrabold sm:text-4xl leading-relaxed text-white [font-family: 'CustomFont']`;
const EnglishHeading = tw.h3`text-xl font-bold mt-2 text-white`; // Using a standard color for gold
const Subtitle = tw.p`mt-4 text-gray-300`;

const SectionHeader = ({ urduTitle, title, subtitle }) => (
  <HeaderContainer>
    <UrduHeading>{urduTitle}</UrduHeading>
    <EnglishHeading>{title}</EnglishHeading>
    {subtitle && <Subtitle>{subtitle}</Subtitle>}
  </HeaderContainer>
);

// Goal Card Components
const GoalsGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6`;
const GoalCard = tw.div`bg-primary-800 bg-opacity-50 p-6 rounded-xl border border-primary-700 hover:bg-primary-700 transition-colors text-center hover:-translate-y-1 transform duration-300`;
const GoalIcon = tw.div`text-4xl mb-4 group-hover:scale-110 transition-transform inline-block`;
const GoalUrduTitle = tw.h4`text-xl mb-2 text-white [font-family: 'CustomFont']`;
const GoalEnglishTitle = tw.p`text-sm text-primary-200 font-medium`;

const FUTURE_GOALS = [
  { title: "Staff Quarters", urdu: "اساتذہ کے لیے رہائش گاہ", icon: "🏠" },
  { title: "Boundary Wall", urdu: "جامعہ کے اطراف حصار بندی", icon: "🧱" },
  { title: "Main Gate", urdu: "باب الداخلہ (مین گیٹ)", icon: "⛩️" },
  { title: "Central Library", urdu: "جنرل لائبریری کی عمارت", icon: "📚" },
  { title: "Rare Books Collection", urdu: "نادر کتب کی فراہمی", icon: "📜" },
  { title: "Grand Mosque", urdu: "جامع مسجد کی تعمیر", icon: "🕌" },
  { title: "Lecture Hall", urdu: "قاعة المحاضرات", icon: "🎙️" },
  { title: "New Departments", urdu: "دیگر تعلیمی شعبہ جات", icon: "🔬" },
];

export default function MustaqbilKeAzaim() {
  return (
    <Container>
      <BackgroundPattern />
      <ContentWrapper>
        <SectionHeader
          urduTitle="مستقبل کے عزائم"
          title="Future Vision"
          subtitle="Our strategic roadmap for expansion and excellence."
        />
        <GoalsGrid>
          {FUTURE_GOALS.map((item, i) => (
            <GoalCard key={i}>
              <GoalIcon>{item.icon}</GoalIcon>
              <GoalUrduTitle>{item.urdu}</GoalUrduTitle>
              <GoalEnglishTitle>{item.title}</GoalEnglishTitle>
            </GoalCard>
          ))}
        </GoalsGrid>
      </ContentWrapper>
    </Container>
  );
}
